export const TRIAL_EXPIRING_DAYS = 30;
